export default __webpack_public_path__ + "a2e7b40a22c9e069faf558980ba712f0.png";